module.exports = __webpack_public_path__ + "media/images/country_flags/et-aa9ef62b0a11906ff68b2b938edcb2ad.png";